export default __webpack_public_path__ + "static/media/instagram.f3e2ae38.svg";